import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, PhoneIcon } from 'lucide-react';
import { company } from '../data/site';
type CtaBandProps = {
  title?: string;
  text?: string;
};
export function CtaBand({
  title = 'Un projet, une panne, un entretien à planifier ?',
  text = "Appelez directement Julien Nésius pour exposer votre besoin. Devis sur demande, sans engagement."
}: CtaBandProps) {
  return <section className="bg-navy-800" data-id="element-43" data-mp="rea1tar28wl6">
      <div className="mx-auto max-w-content px-5 py-14 lg:px-8 lg:py-20" data-id="element-44" data-mp="rd8muv6xbpy6">
        <div className="grid gap-8 lg:grid-cols-12 lg:items-center lg:gap-12" data-id="element-45" data-mp="vfde5n9wgahn">
          <div className="lg:col-span-7" data-id="element-46" data-mp="108oc0ywqhgxf">
            <h2 className="font-display text-2xl font-extrabold leading-tight tracking-tight text-white sm:text-3xl lg:text-[2.4rem]" data-id="element-47" data-mp="109pys0n43ruz">
              {title}
            </h2>
            <p className="mt-4 max-w-xl text-[1.02rem] leading-relaxed text-navy-100" data-id="element-48" data-mp="1a7dvgw4a39fs">
              {text}
            </p>
          </div>
          <div className="flex flex-col gap-3 sm:flex-row lg:col-span-5 lg:justify-end" data-id="element-49" data-mp="1z7db4bmq84zf">
            <a href={company.phoneHref} className="inline-flex items-center justify-center gap-2.5 whitespace-nowrap rounded-xl bg-ember-500 px-6 py-4 font-display text-lg font-bold text-white transition-colors duration-150 ease-out hover:bg-ember-600" data-id="element-50" data-mp="1z50ldcaq8qbt">
              <PhoneIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-51" data-mp="1l9yi6wx9lf2p" />
              {company.phone}
            </a>
            <Link to="/contact" className="inline-flex items-center justify-center gap-2.5 whitespace-nowrap rounded-xl border border-navy-400 px-6 py-4 font-display text-lg font-bold text-white transition-colors duration-150 ease-out hover:bg-navy-700" data-id="element-52" data-mp="2cz1mgcp5ipfc">
              <MailIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-53" data-mp="30oci5frn9tmm" />
              Demander un devis
            </Link>
          </div>
        </div>
      </div>
    </section>;
}